import React from "react";

const Footer = () => {
  return (
    <div className="bg-white  max-w-full bottom-0  h-[60px]  flex  justify-center text-center  text-indigo-500">
      <div>
        <p>
          Meals <span>APP</span> 2023&copy;
        </p>
      </div>
    </div>
  );
};

export default Footer;
